export const KeenSliderNavigation = (options = {}) => {
  return (slider) => {
    let wrapper = options.wrapper;
    let dots, arrowLeft, arrowRight;

    function markup(remove) {
      wrapperMarkup(remove);
      dotMarkup(remove);
      arrowMarkup(remove);
    }

    function removeElement(element) {
      element && element.parentNode && element.parentNode.removeChild(element);
    }

    function createDiv(className) {
      const div = document.createElement("div");
      const classNames = className.split(" ");
      classNames.forEach((name) => div.classList.add(name));
      return div;
    }

    function arrowMarkup(remove) {
      if (remove) {
        removeElement(arrowLeft);
        removeElement(arrowRight);
        return;
      }

      if (!options.arrows) {
        return;
      }

      arrowLeft = slider.container.querySelector("[data-arrow-left]");
      arrowRight = slider.container.querySelector("[data-arrow-right]");

      if (!arrowRight || !arrowLeft) {
        return;
      }

      arrowLeft.onclick = () => slider.prev();
      arrowRight.onclick = () => slider.next();
    }

    function wrapperMarkup(remove) {
      if (remove) {
        const parent = wrapper.parentNode;
        while (wrapper.firstChild)
          parent.insertBefore(wrapper.firstChild, wrapper);
        removeElement(wrapper);
        return;
      }
      if (!options.wrapper) {
        wrapper = createDiv(
          `keen-slider__navigation-wrapper keen-slider__slide-active-${slider.track.details.rel}`
        );
        slider.container.parentNode.appendChild(wrapper);
        wrapper.appendChild(slider.container);
      }
    }

    function dotMarkup(remove) {
      if (remove) {
        removeElement(dots);
        return;
      }

      if (!options.dots) {
        return;
      }

      let slidesPerView = 1;
      if (slider.options?.slides && slider.options?.slides.perView) {
        slidesPerView = slider.options?.slides.perView;
      }

      if (slider.track?.details?.slides.length <= slidesPerView) {
        return;
      }

      if (!options.dots) return;
      const initialButton = options.dots.querySelector("[data-dot-button]");
      options.dots.innerHTML = "";

      slider.track?.details?.slides.forEach((_e, idx) => {
        const newDot = initialButton?.cloneNode(true);
        const newDotInner = newDot.querySelector('[data-dot]');
        newDot.onclick = () => {
          slider.moveToIdx(idx);
        };
        // newDot.ariaLabel = `Navigate to slide ${idx + 1}`;
        if (newDotInner) newDotInner.ariaLabel = `Navigate to slide ${idx + 1}`;
        options.dots.appendChild(newDot);
      });
      options.dots.setAttribute("data-active", "true");
    }

    function updateClasses() {
      const slide = slider.track?.details?.rel;
      if (isNaN(slide)) return;
      if (arrowLeft && arrowRight) {
        slide === 0
          ? arrowLeft.classList.add("arrow--disabled")
          : arrowLeft.classList.remove("arrow--disabled");
        slide === slider.track.details.slides.length - 1
          ? arrowRight.classList.add("arrow--disabled")
          : arrowRight.classList.remove("arrow--disabled");
      }
      if (options?.arrows) {
        const activeCan = slider?.slides[slide];
        slider?.slides.forEach((slide) => {
          slide.ariaCurrent = activeCan === slide;
        });
      }
      if (options.dots) {
        Array.from(options.dots.children).forEach(function (dot, idx) {
          const dotEl = dot.querySelector("[data-dot]");
          if (idx === slide) {
            dot.classList.add("dot--active");
            dotEl.ariaSelected = true;
            slider.slides[idx].ariaHidden = false;
          } else {
            dot.classList.remove("dot--active");
            dotEl.ariaSelected = false;
            slider.slides[idx].ariaHidden = true;
          }
        });
      }
      if (wrapper) {
        wrapper.className = wrapper.className.replace(
          /\b(keen-slider__slide-active-[^\s]+)\b/,
          `keen-slider__slide-active-${slide}`
        );
      }
    }

    slider.on("created", () => {
      markup();
      updateClasses();
    });
    slider.on("optionsChanged", () => {
      if (!options.arrows) {
        markup(true);
        markup();
      }
      updateClasses();
    });
    slider.on("slideChanged", () => {
      updateClasses();
      const activeSlide = slider.slides[slider.track.details.rel];
      activeSlide.setAttribute("tabindex", "-1");
      activeSlide.focus();
    });
    slider.on("destroyed", () => {
      markup(true);
    });
  };
};
